import { Component, Input, OnInit } from '@angular/core';
import { MONTH } from '../../../../core/enums/util.enum';
import { CurrentOrdersService } from '../../../../core/services/current-orders.service';
import { CurrentOrderLocation } from '../../../../core/models/live-order.model';
import { RestaurantAddress } from '../../../../core/models/restaurant.model';

@Component({
  selector: 'app-current-orders-footer',
  templateUrl: './current-orders-footer.component.html',
  styleUrls: ['./current-orders-footer.component.scss'],
})
export class CurrentOrdersFooterComponent implements OnInit {
  @Input() public isGroup: boolean;
  public now: Date = new Date();
  public location: CurrentOrderLocation = new CurrentOrderLocation();
  public mask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

  constructor(
    private currentOrderService: CurrentOrdersService
  ) {
    setInterval(() => {
      this.now = new Date();
    }, 1);

    this.currentOrderService.getLocation()
      .subscribe(restaurant => {
        this.location = restaurant;
        if (this.location.phone.substr(0, 1) === '1') {
          this.location.phone = this.location.phone.slice(1);
        }
      });
  }

  ngOnInit() {}

  public getMoth(): string {
    let currentMonth: string;
    MONTH.map(month => {
      if (month.index === this.now.getMonth() + 1) {
        currentMonth = month.month;
      }
    });
    return currentMonth;
  }

  public getTime(): string {
    let hours = this.now.getHours();
    let minutes: string | number = this.now.getMinutes();
    const ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    return hours + ':' + minutes + ' ' + ampm;
  }
  public get address(): string {
    let address = '';
    if (this.location.address != null) {
      const addressObject: RestaurantAddress = this.location.address;
      const addressFields: string[] = ['addressLine', 'locality', 'state', 'postalCode'];
      for (const field of addressFields) {
        if (addressObject[field] != null) {
          address += field !== 'state' ? this.titleCase(addressObject[field]) : addressObject[field];
          address += addressObject[field].length > 0 && field !== 'state' && field !== 'postalCode' ? ',' : '';
          address += addressObject[field].length > 0 && field !== 'postalCode' ? ' ' : '';
        }
      }
      address = address.trim().endsWith(',') ? address.trim().slice(0, -1) : address.trim();
    }
    return address;
  }

  private titleCase(str: string) {
    return str.toLowerCase().split(' ').map(function(word) {
      return (word.charAt(0).toUpperCase() + word.slice(1));
    }).join(' ');
  }

}
